<template>
    <div class="daily-chart">
        <div class="energy-consumption-chart">
            <h3 class="title">{{getText('simulation_daily_chart_energy_title')}}</h3>
            <div class="energyConsumption" ref="energyConsumption"></div>
        </div>
        <div class="time-sharing-chart">
            <h3 class="title">{{getText('simulation_daily_chart_time_sharing_title')}}</h3>
            <div class="timeSharing" ref="timeSharing"></div>
            <div class="legends">
                <div class="stopped">
                    <div class="square"></div>
                    <span class="text">{{getText('simulation_daily_chart_time_sharing_legend_stop')}}</span>
                </div>
                <div class="charging">
                    <div class="square"></div>
                    <span class="text">{{getText('simulation_daily_chart_time_sharing_legend_empty')}}</span>
                </div>
                <div class="working">
                    <div class="square"></div>
                    <span class="text">{{getText('simulation_daily_chart_time_sharing_legend_working')}}</span>
                </div>
            </div>
        </div>
        <div class="money-consumption-chart">
            <h3 class="title">{{getText('simulation_daily_chart_economic_title')}}</h3>
            <div class="moneyConsumption" ref="moneyConsumption"></div>
        </div>
        <div class="daily-stats-chart">
            <h3 class="title">{{getText('simulation_daily_chart_stats')}}</h3>
            <div class="dailyStats" ref="dailyStats"></div>
            <div class="legends">
                <span>{{getText('simulation_daily_chart_legends_pmax_extreme')}}</span>
                <span>{{getText('simulation_daily_chart_legends_pmax')}}</span>
                <span>{{getText('simulation_daily_chart_legends_average')}}</span>
                <span>{{getText('simulation_daily_chart_legends_pmin')}}</span>
                <span>{{getText('simulation_daily_chart_legends_pmin_extreme')}}</span>
            </div>
        </div>
        <div class="daily-stats-chart-example">
            <h3 class="title">Lecture du graphique "Statistiques Journalières"</h3>
            <img src="/static/img/Example_Moustache.png" alt="Exemple de lecture du graph à moustache">
        </div>
    </div>
</template>

<script>

import {scaleBand, scaleLinear, axisBottom, axisLeft, select, max, scalePoint, min} from 'd3';
import {mapGetters} from 'vuex';
export default {

    components: {

    },

    props: {
        dataStat: {
            type: Array,
            required: true
        }
    },

    data: function(){
        return {
            windowWidth: null,
            margin: {
                top: 10,
                right: 20,
                bottom: 30,
                left: 40
            },
            chartWidth: 500,
            chartHeight: 200,
        };
    },

    computed: {
        ...mapGetters([
            'getText',
        ]),
        width() {
            return this.chartWidth - this.margin.left - this.margin.right;
        },
        height() {
            return this.chartHeight - this.margin.top - this.margin.bottom;
        },
        x() {
            return scaleBand().rangeRound([0, this.width], .1).padding([0.6]);
        },
        y() {
            return scaleLinear().range([this.height, 0]);
        },
        xAxis() {
            return axisBottom().scale(this.x);
        },
        yAxis() {
            return axisLeft().scale(this.y);
        }
    },

    created() {
        window.addEventListener('resize', this.handleResize);
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },

    mounted: function(){
        this.handleResize();
    },

    methods: {
        handleResize() {
            this.destroyGraph();
            this.chartWidth = this.$refs.energyConsumption.offsetWidth || 500;
            this.createGraphConsoEnergy();
            this.createGraphTimeSharing();
            this.createGraphConsoMoney();
            this.createGraphDailyStat();
        },
        destroyGraph(){
            if (this.$refs.energyConsumption.children.length) {
                this.$refs.energyConsumption.children[1].remove();
                this.$refs.energyConsumption.children[0].remove();
            }
            if (this.$refs.timeSharing.children.length) {
                this.$refs.timeSharing.children[1].remove();
                this.$refs.timeSharing.children[0].remove();
            }
            if (this.$refs.moneyConsumption.children.length) {
                this.$refs.moneyConsumption.children[1].remove();
                this.$refs.moneyConsumption.children[0].remove();
            }
            if (this.$refs.dailyStats.children.length) {
                this.$refs.dailyStats.children[1].remove();
                this.$refs.dailyStats.children[0].remove();
            }
        },
        createGraphConsoEnergy() {
            var div = select('.energyConsumption').append('div').attr('class', 'tooltip').style('opacity', 0);

            var svg = select('.energyConsumption').append('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            this.x.domain(this.dataStat.map(d => d.date));
            this.y.domain([0, max(this.dataStat, d => d.conso_MWh)]);

            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + this.height + ')')
                .call(this.xAxis);

            svg.append('g')
                .attr('class', 'y axis')
                .call(this.yAxis)
                .append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 6)
                .attr('dy', '.71em')
                .style('text-anchor', 'end')
                .text('Frequency');

            svg.selectAll('.blue')
                .data(this.dataStat)
                .enter().append('rect')
                .attr('class', 'blue')
                .attr('x', d => this.x(d.date))
                .attr('width', this.x.bandwidth())
                .attr('y', d => this.y(d.conso_MWh))
                .attr('height', d => this.height - this.y(d.conso_MWh))
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', .9);
                    div.html(`${d.conso_MWh} MWh`).style(
                        'left',
                        this.x(d.date) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });
        },
        createGraphConsoMoney() {
            var div = select('.moneyConsumption').append('div').attr('class', 'tooltip').style('opacity', 0);

            var svg = select('.moneyConsumption').append('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            this.x.domain(this.dataStat.map(d => d.date));
            this.y.domain([0, max(this.dataStat, d => d.conso_euros)]);

            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + this.height + ')')
                .call(this.xAxis);

            svg.append('g')
                .attr('class', 'y axis')
                .call(this.yAxis)
                .append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 6)
                .attr('dy', '.71em')
                .style('text-anchor', 'end')
                .text('Frequency');

            svg.selectAll('.blue')
                .data(this.dataStat)
                .enter().append('rect')
                .attr('class', 'blue')
                .attr('x', d => this.x(d.date))
                .attr('width', this.x.bandwidth())
                .attr('y', d => this.y(d.conso_euros))
                .attr('height', d => this.height - this.y(d.conso_euros))
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', .9);
                    div.html(`${d.conso_euros} €`).style(
                        'left',
                        this.x(d.date) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });
        },
        createGraphTimeSharing() {
            var div = select('.timeSharing').append('div').attr('class', 'tooltip').style('opacity', 0);

            var svg = select('.timeSharing').append('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            this.x.domain(this.dataStat.map(d => d.date));
            this.y.domain([0, 100]);

            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + this.height + ')')
                .call(this.xAxis);

            svg.append('g')
                .attr('class', 'y axis')
                .call(this.yAxis)
                .append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y', 6)
                .attr('dy', '.71em')
                .style('text-anchor', 'end')

            svg.selectAll('.blue')
                .data(this.dataStat)
                .enter().append('rect')
                .attr('class', 'blue')
                .attr('x', d => this.x(d.date))
                .attr('width', this.x.bandwidth())
                .attr('y', d => this.y(d.pm_25_50 + d.pm_50_75 + d.pm_75_100))
                .attr('height', d => this.height - this.y(d.pm_25_50 + d.pm_50_75 + d.pm_75_100))
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', .9);
                    div.html(`${Math.round((d.pm_25_50 + d.pm_50_75 + d.pm_75_100) * 100) / 100} %`).style(
                        'left',
                        this.x(d.date) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });
            svg.selectAll('.orange')
                .data(this.dataStat)
                .enter().append('rect')
                .attr('class', 'orange')
                .attr('x', d => this.x(d.date))
                .attr('width', this.x.bandwidth())
                .attr('y', d => this.y(d.pm_2_25 + d.pm_25_50 + d.pm_50_75 + d.pm_75_100))
                .attr('height', d => this.height - this.y(d.pm_2_25))
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', .9);
                    div.html(`${Math.round(d.pm_2_25 * 100) / 100} %`).style(
                        'left',
                        this.x(d.date) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });
            svg.selectAll('.grey')
                .data(this.dataStat)
                .enter().append('rect')
                .attr('class', 'grey')
                .attr('data-legend', 'test')
                .attr('x', d => this.x(d.date))
                .attr('width', this.x.bandwidth())
                .attr('y', d => this.y(d.pm_0_2 + d.pm_2_25 + d.pm_25_50 + d.pm_50_75 + d.pm_75_100))
                .attr('height', d => this.height - this.y(d.pm_0_2))
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', .9);
                    div.html(`${Math.round(d.pm_0_2 * 100) / 100} %`).style(
                        'left',
                        this.x(d.date) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });
        },
        createGraphDailyStat() {
            let barWidth = 30;
            var div = select('.dailyStats').append('div').attr('class', 'tooltip').style('opacity', 0);


            // Prepare the data for the box plots
            let boxPlotData = [];
            this.dataStat.forEach(item => {
                let obj = {
                    key: item.date,
                    quartile: [item.min, item.moy, item.max],
                    whiskers: [item.e_min, item.e_max]
                };
                boxPlotData.push(obj);
            });

            // Compute an ordinal xScale for the keys in boxPlotData
            let xScale = scalePoint()
                .domain(this.dataStat.map(d => d.date))
                .rangeRound([0, this.width])
                .padding([0.5]);

            // Compute a global y scale based on the global counts
            let yScale = scaleLinear()
                .domain([min(this.dataStat, d => d.e_min), max(this.dataStat, d => d.e_max)])
                .range([this.height, 0]);


            // append the svg obgect to the body of the page
            // appends a 'group' element to 'svg'
            // moves the 'group' element to the top left margin
            let svg = select('.dailyStats').append('svg')
                .attr('width', this.width + this.margin.left + this.margin.right)
                .attr('height', this.height + this.margin.top + this.margin.bottom)
                .append('g')
                .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

            // append a group for the box plot elements
            let g = svg.append('g');

            // Draw the box plot vertical lines
            let verticalLines = g.selectAll('.verticalLines')
                .data(boxPlotData)
                .enter()
                .append('line')
                .attr('x1', d => xScale(d.key))
                .attr('y1', d => yScale(d.whiskers[0]))
                .attr('x2', d => xScale(d.key))
                .attr('y2', d => yScale(d.whiskers[1]))
                .attr('stroke', '#000')
                .attr('stroke-width', 1)
                .attr('fill', 'none');

            // Draw the boxes of the box plot, filled and on top of vertical lines
            let rects = g.selectAll('rect')
                .data(boxPlotData)
                .enter()
                .append('rect')
                .attr('width', barWidth)
                .attr('height', d => {
                    let quartiles = d.quartile;
                    let height =  yScale(quartiles[0]) - yScale(quartiles[2]);
                    return height;
                })
                .attr('x', d => xScale(d.key) - (barWidth/2))
                .attr('y', d => yScale(d.quartile[2]))
                .attr('fill', 'steelblue')
                .attr('stroke', '#000')
                .attr('stroke-width', 1)
                .on('mouseover', d => {
                    div.transition().duration(0).style('z-index', 1);
                    div.transition().duration(200).style('opacity', 1);
                    div.html(`- ${Math.round(d.whiskers[1])} kW<br>- ${Math.round(d.quartile[2])} kW<br>- ${Math.round(d.quartile[1])} kW<br>- ${Math.round(d.quartile[0])}kW<br>- ${Math.round(d.whiskers[0])} kW`).style(
                        'left',
                        xScale(d.key) + 'px'
                    ).style(
                        'top',
                        25 + 'px'
                    );
                })
                .on('mouseout', () => {
                    div.transition().duration(200).style('opacity', 0).style('z-index', 0);
                });


            // Now render all the horizontal lines at once - the whiskers and the median
            let horizontalLineConfigs = [
                // Top whisker
                {
                    x1: d => xScale(d.key) - barWidth/2,
                    y1: d => yScale(d.whiskers[0]),
                    x2: d => xScale(d.key) + barWidth/2,
                    y2: d => yScale(d.whiskers[0])
                },
                // Median line
                {
                    x1: d => xScale(d.key) - barWidth/2,
                    y1: d => yScale(d.quartile[1]),
                    x2: d => xScale(d.key) + barWidth/2,
                    y2: d => yScale(d.quartile[1])
                },
                // Bottom whisker
                {
                    x1: d => xScale(d.key) - barWidth/2,
                    y1: d => yScale(d.whiskers[1]),
                    x2: d => xScale(d.key) + barWidth/2,
                    y2: d => yScale(d.whiskers[1])
                }
            ];

            for(let i=0; i < horizontalLineConfigs.length; i++) {
                let lineConfig = horizontalLineConfigs[i];

                // Draw the whiskers at the min for this series
                let horizontalLine = g.selectAll('.whiskers')
                    .data(boxPlotData)
                    .enter()
                    .append('line')
                    .attr('x1', lineConfig.x1)
                    .attr('y1', lineConfig.y1)
                    .attr('x2', lineConfig.x2)
                    .attr('y2', lineConfig.y2)
                    .attr('stroke', '#000')
                    .attr('stroke-width', 1)
                    .attr('fill', 'none');
            }


            //x-axis
            svg.append('g')
                .attr('transform', 'translate(0,' + this.height + ')')
                .call(axisBottom(xScale));

            // Add the Y Axis
            svg.append('g')
                .call(axisLeft(yScale));

        }
    }
};
</script>

<style lang="less">
.daily-chart {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    text-align: left;
    margin-top: 30px;
    .dailyStats, .energyConsumption, .timeSharing, .moneyConsumption{
        height: 200px;
        max-height: 200px;
        svg {
            position: absolute;
            top: 20%;
        }
        .tooltip {
            z-index: 0;
        }
    }
    .energy-consumption-chart, .time-sharing-chart, .money-consumption-chart, .daily-stats-chart {
        position: relative;
        margin-left: 5%;
        height: 300px;
        margin-right: 5%;
        width: 40%;
        .title {
            text-align: center;
            font-weight: bold;
        }
        rect.blue {
            fill: steelblue;
        }
        rect.orange {
            fill: orange;
        }
        rect.grey {
            fill: darkgrey;
        }
        .axis path,
        .axis line {
            fill: none;
            stroke: #000;
            shape-rendering: crispEdges;
        }

        rect.blue:hover {
            fill: #223f56 ;
        }
        rect.orange:hover {
            fill: orangered ;
        }
        rect.grey:hover {
            fill: grey ;
        }

        .x.axis path {
            display: none;
        }
        .tooltip {
            position: absolute;
            color: white;
            text-align: center;
            font-size: 15px;
            line-height: 15px;
            font-weight: bold;
            width: 120px;
            padding-bottom: 6px;
            background-color: #E9F0A2;
            color: #6B7500;
        }
    }
    .money-consumption-chart, .daily-stats-chart {
        margin-top: 20px;
    }
    .time-sharing-chart, .daily-stats-chart {
        margin-left: 0;
        margin-right: 10%;
    }
    .daily-stats-chart {
        position: relative;
        .tooltip {
            text-align: left;
            width: 120px;
        }
        .legends {
            position: absolute;
            top: 10%;
            right: -20%;
            width: 100px;
            bottom: 10%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
    .time-sharing-chart {
        position: relative;
        .legends {
            position: absolute;
            top: 30%;
            right: -10%;
            .working, .charging, .stopped {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .square {
                    width: 7px;
                    height: 7px;
                    margin-right: 7px;
                }
            }
            .working {
                .square {
                    background-color: steelblue;
                }
            }
            .charging {
                .square {
                    background-color: orange;
                }
            }
            .stopped {
                .square {
                    background-color: darkgrey;
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/simulationDailyChart.vue